import React, { useState, useEffect } from 'react';
import { HeaderComponent, FooterComponent, ExpectDialog, LoadingDialog } from '../../shared-component';
import AppTool from '@/apps/@utils/app-tool';


const PrivacyPage = ({ item }) => {

  useEffect(() => {
    setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);
  }, []);

  return (
    <div className="cPrivacyPage">
      <ExpectDialog />
      <HeaderComponent />
      <LoadingDialog />
      <div className='cPcBox'>
        <img className="cImage" src={window.assetUrl(`/images/privacy/pc_privacy.png`)} />
      </div>
      <div className='cPhoneBox'>
        <img className="cImage" src={window.assetUrl(`/images/privacy/mobile_privacy.png`)} />
      </div>
      <FooterComponent />
    </div>
  );
};

export default PrivacyPage;

